export const ENDPOINT = {
  MEMBER_DETAILS: options => `/_api/wix-sm-webapp/member/?collectionId=${options.smcollectionId}&metaSiteId=${options.metaSiteId}`
};
//# sourceMappingURL=constants.js.map